/*****************
 * Login events  *
 *****************/

// submit login modal also when enter is pressed
$('body').on('keypress', function (event) {
    var keyCode = event.keyCode;
    var isLoginModalVisible = $('#login-modal').is(':visible');

    if (keyCode === 13 && isLoginModalVisible) {
        $('#login-modal-form').submit();
    }
});

$('body').on('click', '#login-modal-close', function (e) {
    iris.unsetButtonLoading($('#login-modal-login'));
});

$('body').on('click', '#login-modal-button', function (e) {
    $('#login-modal-form').submit();
});

$('body').on('click', '#login-bp-button', function (e) {
    $('#login-bp-form').submit();
});

$('body').on('click', '#login-cva-button', function (e) {
    $('#login-cva-form').submit();
});